import apiClient from "./api";
import { getApiAccessToken } from "./UserService";
import { 
  ContractDefaultUsersData,
  ContractDefaultUsersRequest,
  AddressSystemDropdownItem,
  ContractStatusDropdownItem
} from "../types/ContractDefaultUsers";

const baseUrl = '/api/ContractDefaultUsers';

export const getAddressSystems = async (): Promise<AddressSystemDropdownItem[]> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get(`${baseUrl}/address-systems`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data as AddressSystemDropdownItem[];
};

export const getContractStatuses = async (addressSystemId: number): Promise<ContractStatusDropdownItem[]> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get(`${baseUrl}/contract-statuses/${addressSystemId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data as ContractStatusDropdownItem[];
};

export const getContractDefaultUsersData = async (
  addressSystemId: number, 
  contractStatusId: number
): Promise<ContractDefaultUsersData> => {
  const token = await getApiAccessToken();
  const response = await apiClient.get(`${baseUrl}/data`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: { 
      addressSystemId, 
      contractStatusId 
    }
  });
  return response.data as ContractDefaultUsersData;
};

export const saveContractDefaultUsers = async (request: ContractDefaultUsersRequest): Promise<void> => {
  const token = await getApiAccessToken();
  await apiClient.post(`${baseUrl}/save`, request, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};